/**
 *  * 监控页面API
 * @date 2025-04-15
 * @author jyh
 */

import instance from '@/utils/axios';

/**
 * 无线盒子列表数据
 * @returns
 */
export function getBoxDeviceServer(deviceTypeCode) {
  //   return instance.get('/wirelessBox/getBoxDevice');

  return instance.get(`/wirelessBox/getBoxDevice?deviceTypeCode=${deviceTypeCode}`);
}

/**
 * 天气信息
 * @param {*} longitude
 * @param {*} latitude
 * @returns
 */
export function weatherInfoServer(longitude, latitude) {
  return instance.get(`/weather/condition/info?longitude=${longitude}&latitude=${latitude}`);
}

/**
 * 获取实时数据
 * @param {*} sn
 * @returns
 */
export function droneRealTimeServer(sn) {
  return instance.get(`/wirelessBox/getBoxDeviceData?sn=${sn}`);
}

/**
 * 无线盒子原始数据
 * @param {*} data
 * @returns
 */
export function boxOriginDataServer(data) {
  return instance.get('/stat/queryWirelessBoxOrdata', { params: data });
}

/**
 * 查询传感器等级
 * @param {*} data
 * @returns
 */
export function getSensorsGradeServer(data) {
  return instance.post('/stat/getDeviceSensorTypeGrade', data);
}
